import DataTable from "components/DataTable/DataTable";
import React from "react";
import { selectApplicationHistoryByApplicationId } from "store/domain-data/application-history/applicationHistory";
import { useStoreSelector } from "store/hooks";
import { useParticipantHistoryColumns } from "./functions/useParticipantHistoryColumns";
import { useInfiniteScroll } from "hooks/useInfiniteScroll";
import { OnChangeFn, SortingState } from "@tanstack/react-table";
import { ApplicationHistorySortCriteria } from "models/ApplicationHistorySortCriteria.model";
import { SortDirection } from "models/SortDirection.model";
import { ApplicationHistoryEntityType } from "models/Application.model";

type Props = {
  applicationId: number;
  participantId: number;
  sortCriteria?: ApplicationHistorySortCriteria;
  sortDirection?: SortDirection;
  loadNextPage: () => void;
  hasNextPage: boolean;
  onSortingChange?: OnChangeFn<SortingState>;
};

const ParticipantHistoryTable: React.FC<Props> = ({
  participantId,
  applicationId,
  hasNextPage,
  sortCriteria,
  sortDirection,
  loadNextPage,
  onSortingChange,
}) => {
  const participantHistory = useStoreSelector((state) =>
    selectApplicationHistoryByApplicationId(state, {
      applicationId,
      entityId: participantId,
      entity: ApplicationHistoryEntityType.Participant,
    })
  );
  const columns = useParticipantHistoryColumns();
  const tableRef = React.useRef<HTMLDivElement>(null);

  const handleScrollPositionChange = React.useCallback(() => {
    if (!hasNextPage) {
      return;
    }
    loadNextPage();
  }, [hasNextPage, loadNextPage]);

  useInfiniteScroll({
    scrollElement: tableRef.current,
    onScrollLimitReached: handleScrollPositionChange,
  });

  return (
    <DataTable
      ref={tableRef}
      data={participantHistory}
      columns={columns}
      sortById={sortCriteria}
      sortDesc={sortDirection === SortDirection.Descending}
      tableLayout={"fixed"}
      verticalAlign={"top"}
      onSortingChange={onSortingChange}
    />
  );
};

export default ParticipantHistoryTable;
